import React from 'react';
import { Car, Shield, Clock, CheckCircle } from 'lucide-react';

const HeroSection = () => {
  const scrollToForm = () => {
    document.getElementById('credit-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const features = [
    { icon: Clock, text: "Quick Approval" },
    { icon: Shield, text: "Secure & Confidential" },
    { icon: CheckCircle, text: "All Credit Welcome" },
  ];

  return (
    <section className="relative bg-zinc-950 overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-zinc-900 via-zinc-950 to-zinc-900" />
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-teal-900/10 to-transparent" />
      
      {/* Subtle grid pattern */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-teal-500/10 border border-teal-500/20 rounded-full px-4 py-2 mb-8">
            <Car className="h-4 w-4 text-teal-400" />
            <span className="text-teal-400 text-sm font-medium">Vehicle Financing Made Easy</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Get Pre-Approved for Your
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-emerald-400">
              Dream Vehicle
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto leading-relaxed">
            Complete our simple credit application and take the first step towards driving home in your new vehicle. Fast, secure, and hassle-free financing options.
          </p>

          {/* CTA Button */}
          <button
            onClick={scrollToForm}
            className="group inline-flex items-center gap-3 bg-teal-500 hover:bg-teal-400 text-zinc-900 font-semibold px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg hover:shadow-teal-500/25"
          >
            <span>Start Your Application</span>
            <svg
              className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-8 mt-12">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2 text-gray-400">
                <feature.icon className="h-5 w-5 text-teal-400" />
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-zinc-900 to-transparent" />
    </section>
  );
};

export default HeroSection;
